import React, { useEffect, useRef, useState } from "react";
import { Container, IconButton, TextField, Typography, makeStyles } from "@material-ui/core";
import {
  FilterItems,
  FilterSelectionButton,
  PrimaryButton,
  PrimaryTextButton,
} from "../components-atoms";
import { ITheme, theme } from "../constants/theme";
import Button from "@material-ui/core/Button";
import CloseRounded from "@material-ui/icons/CloseRounded";

import { FilterList } from "@material-ui/icons";
import { IPromotionCodeFilter } from "../redux/actions/promotionCodes";
import { IListReferralCodesRequestFilter } from "../redux/actions/referralCodes";
import Menu from "@material-ui/core/Menu";
import { TabPanel } from "../components-molecules";
import { IFilterItem } from "../utils/promo-code/headerOptions";
import BackButton from "../components-atoms/BackButton";
import { buttonHoverAndActive, textButtonHoverAndActive } from "../utils/styles/buttonStyles";

export interface IFilter {
  [key: string]: Array<string | number | boolean> | undefined;
}
interface IFilterButtonWithTitleProps {
  onSubmit: (thisFilter: IFilter | IPromotionCodeFilter | IListReferralCodesRequestFilter) => void;
  inButtonSet: boolean;
  options: IFilterItem[];
  filter: IFilter | IPromotionCodeFilter | IListReferralCodesRequestFilter;
  defaultOption: string;
  dateKey?: string;
  singleDate?: boolean;
  searchableList?: string[];
}

export const FilterButtonWithTitle = ({
  onSubmit,
  inButtonSet,
  options,
  filter,
  defaultOption,
  searchableList = [],
}: IFilterButtonWithTitleProps) => {
  const classes = useStyles();
  const searchInputRef = useRef<any>();
  const [thisFilter, setThisFilter] = useState<IFilter | IPromotionCodeFilter | IListReferralCodesRequestFilter>(
    filter
  );
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedOption, setSelectedOption] = useState<string>(defaultOption);
  const [submittedFilter, setSubmittedFilter] = useState({});
  const [index, setIndex] = useState(0);
  const [filterSearch, setFilterSearch] = useState<string>("");
  const [optionsCopy, setOptionsCopy] = useState(options);
  const open = Boolean(anchorEl);
  const currentMenu = optionsCopy.find((o) => o.key === selectedOption);

  useEffect(() => {
    setOptionsCopy(options);
  }, [options]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (): void => {
    setIndex(0);
    setFilterSearch("");
    setOptionsCopy(options);
    setAnchorEl(null);
  };
  const filterButtonClicked = (option: string): void => {
    setSelectedOption(option);
    setFilterSearch("");
    setOptionsCopy(options);
    setIndex(1);
  };
  const onItemChange = (
    checked: boolean,
    value: string | number | boolean
  ): void => {
    if (checked) {
      const tempItem = thisFilter[selectedOption] || [];
      setThisFilter({ ...thisFilter, [selectedOption]: [...tempItem, value] });
    } else {
      const tempSelectedOption = thisFilter[selectedOption]?.filter(
        (f) => f !== value
      );
      setThisFilter({ ...thisFilter, [selectedOption]: tempSelectedOption });
    }
  };
  const isFilterEmpty = (): boolean => {
    let result: boolean = true;
    if (index === 1) {
      return thisFilter[selectedOption]?.length === 0;
    }
    Object.keys(thisFilter).forEach((key) => {
      const tempItem = thisFilter[key] || [];
      if (tempItem.length > 0) {
        result = false;
      }
    });
    return result;
  };
  const getActiveFilterCount = (): number => {
    return Object.keys(submittedFilter).filter(
      (key: string) => submittedFilter[key].length > 0
    ).length;
  };

  const clearFilter = (): void => {
    if (index === 1) {
      setThisFilter({ ...thisFilter, [selectedOption]: [] });
    } else {
      let tempFilter = {};
      Object.keys(thisFilter).forEach((key) => {
        tempFilter = { ...tempFilter, [key]: [] };
      });
      setThisFilter(tempFilter);
    }
  };
  const selectAll = (): void => {
    const tempSelectedOptions = currentMenu?.options.map(
      (filterItem) => filterItem.value
    );
    setThisFilter({ ...thisFilter, [selectedOption]: tempSelectedOptions });
  };

  const renderApplyButton = () => {
    return (
      <Container className={classes.bottomButtonContainer}>
        <PrimaryButton
          disabled={false}
          title="Apply Filters"
          style={{ width: "100%", height: 36 }}
          onClick={() => {
            setSubmittedFilter(thisFilter);
            onSubmit(thisFilter);
            handleClose();
          }}
        />
      </Container>
    );
  };

  const renderFilterList = () => {
    return (
      <TabPanel value={index} index={0}>
        <Container className={classes.tabContainer}>
          {options?.map((opt) => {
            const { key, title, options } = opt;
            const tempItem = thisFilter[key] || [];
            return (
              <FilterSelectionButton
                key={key}
                title={title}
                onClick={() => filterButtonClicked(key)}
                selectedFilters={options
                  ?.filter((f) => tempItem.includes(f.value))
                  .map((item) => item.title)}
              />
            );
          })}
        </Container>
      </TabPanel>
    );
  };

  const renderDetailList = () => {
    return (
      <Container
        className={classes.tabContainer}
        style={{ padding: "8px 16px" }}
      >
        <TabPanel style={{ paddingTop: 0 }} value={index} index={1}>
          {searchableList.includes(selectedOption) ? (
            <TextField
              size="small"
              inputRef={searchInputRef}
              className={classes.searchInput}
              variant="outlined"
              placeholder={`Search ${currentMenu?.title || ''}`}
              label={`Search ${currentMenu?.title || ''}`}
              value={filterSearch}
              onChange={(e) => {
                const val = e.target.value;
                setFilterSearch(val);

                if (!val) {
                  setOptionsCopy(options);
                  return;
                }

                const updated = options.map((optionGroup) => {
                  if (optionGroup?.key === selectedOption) {
                    return {
                      ...optionGroup,
                      options: (optionGroup.options || []).filter((opt) =>
                        String(opt.title).toLowerCase().includes(val.toLowerCase())
                        || String(opt?.helperText).toLowerCase().includes(val.toLowerCase())
                      ),
                    };
                  }
                  return optionGroup;
                });

                setOptionsCopy(updated);
              }}
              InputProps={{
                endAdornment: filterSearch ? (
                  <IconButton
                    edge="end"
                    onClick={() => {
                      setFilterSearch("");
                      setOptionsCopy(options);
                    }}
                    size="small"
                    className={classes.clearSearchIconButton}
                  >
                    <CloseRounded
                      className={classes.clearSearchIcon}
                      fontSize="small"
                    />
                  </IconButton>
                ) : undefined,
              }}
            />
          ) : (
            <></>
          )}
          {currentMenu && currentMenu.options?.length > 0 ? (
            currentMenu.options.map((filterItem) => {
              const tempItem = thisFilter[selectedOption]
                ? [...thisFilter[selectedOption]]
                : [];

              return (
                <FilterItems
                  checked={
                    tempItem.filter((f) => f === filterItem.value).length > 0
                  }
                  key={filterItem.value + filterItem.title}
                  title={filterItem.title}
                  helperText={filterItem?.helperText}
                  onChange={(checked: boolean) => {
                    onItemChange(checked, filterItem.value);
                  }}
                />
              );
            })
          ) : (
            <Typography
              variant="caption"
              component="p"
              color="inherit"
              className={classes.noResultsText}
            >
              No Results
            </Typography>
          )}
        </TabPanel>
      </Container>
    );
  };
  return (
    <div>
      <Button
        id="filter-button"
        data-automation="filter-button"
        aria-label="Filter"
        aria-controls={open ? "filter-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        startIcon={<FilterList color="primary" />}
        onClick={handleClick}
        style={{
          marginLeft: inButtonSet ? "8px" : undefined,
          backgroundColor: open
            ? theme.palette.secondary.main
            : getActiveFilterCount()
              ? theme.palette.secondary[24]
              : undefined,
        }}
        className={classes.textButton}
      >
        <Typography
          variant="button"
          component="span"
          color="primary"
          className={classes.printButtonText}
        >
          Filter{!!getActiveFilterCount() && ` · ${getActiveFilterCount()}`}
        </Typography>
      </Button>

      <Menu
        id="filter-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{ className: classes.menuPaper }}
        MenuListProps={{
          "aria-labelledby": "filter-button",
          role: "listbox",
          className: classes.menuList,
        }}
        className={classes.menu}
      >
        <Container
          onFocusCapture={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (searchInputRef && searchInputRef.current) {
              searchInputRef.current.focus();
            }
          }}
          className={classes.titleContainer}
        >
          {index === 1 && (
            <BackButton
              onClick={() => setIndex(0)}
            />
          )}
          <Typography
            variant="h6"
            component="span"
            color="textPrimary"
            style={{ marginLeft: index === 1 ? 16 : 8 }}
          >
            {index === 0
              ? "Filter"
              : options.find((o) => o.key === selectedOption)?.title}
          </Typography>
        </Container>
        <Container className={classes.buttonContainer}>
          {index === 1 && (
            <PrimaryTextButton
              id="basic-button"
              aria-controls="basic-menu"
              aria-haspopup="true"
              title="Select All"
              onClick={() => selectAll()}
              style={{ padding: "6px 12px" }}
            />
          )}
          <PrimaryTextButton
            id="basic-button"
            aria-controls="basic-menu"
            aria-haspopup="true"
            title="Clear All"
            disabled={isFilterEmpty()}
            onClick={() => clearFilter()}
            style={{ padding: "6px 12px" }}
          />
        </Container>

        {renderFilterList()}
        {renderDetailList()}
        {renderApplyButton()}
      </Menu>
    </div>
  );
};

const useStyles = makeStyles((theme: ITheme) => ({
  printButtonText: {
    textTransform: "none",
  },
  buttonText: {
    textTransform: "none",
  },
  buttonIcon: {
    width: 18,
    height: 18,
    marginRight: 8,
  },
  titleContainer: {
    minWidth: 320,
    padding: "8px 8px 16px 8px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  buttonContainer: {
    paddingLeft: 4,
  },
  bottomButtonContainer: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 24,
    paddingBottom: 16,
  },
  tabContainer: {
    flex: 1,
    width: "100%",
    maxWidth: 320,
    paddingLeft: 4,
    paddingRight: 4,
    "overflow-y": "auto",
  },
  menuList: {
    height: 560,
    width: 320,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  menu: {
    marginTop: 65,
    marginRight: 120,
    "& [class*=MuiPaper-rounded-]": {
      top: 79,
      borderRadius: 12,
    },
  },
  primaryButton: {
    width: "100%",
    borderRadius: 8,
    ...buttonHoverAndActive
  },
  textButton: {
    borderRadius: 8,
    ...textButtonHoverAndActive
  },
  searchInput: {
    width: "100%",
  },
  clearSearchIconButton: {
    paddingRight: 0,
  },
  clearSearchIcon: {
    color: theme.palette.text.secondary,
  },
  menuPaper: {
    borderRadius: 12,
  },
  noResultsText: {
    paddingTop: 8,
    color: theme.palette.text.secondary,
  },
}));
